export default __webpack_public_path__ + "static/media/lix-logo.3a26c7f1.svg";